import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "25",
  height: "26",
  fill: "none",
  viewBox: "0 0 25 26"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      width: "25",
      height: "25",
      y: ".5",
      fill: "#93E19F",
      rx: "4"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#248232",
      "fill-rule": "evenodd",
      d: "M5 10.961c0 .145.103.269.235.345q.165.096.31.25c.278.307.467.787.467 1.444s-.189 1.137-.468 1.443a1.3 1.3 0 0 1-.309.25c-.132.077-.235.201-.235.346V17c0 .25.25.5.5.5h13.643c.607 0 .857-.367.857-.8V9.2c0-.7-.553-.7-.75-.7H5.5c-.25 0-.5.25-.5.5z",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#fff",
      d: "M9 10.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0M9 13a1 1 0 1 1-2 0 1 1 0 0 1 2 0M9 15.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0"
    }, null, -1)
  ]))]))
}
export default { render: render }